import './NewMessagesButton.scss'
import Button from 'devextreme-react/button';
import { useState } from 'react';
import Popup from 'devextreme-react/popup';
import { useAuth } from '../../../../contexts/auth';
import NewMessageList from './NewMessageList';
import { useNavigate } from 'react-router-dom';
import { useGetUnreadMessageCount } from '../api/get-unread-message-count';

export default function NewMessagesButton() {

	const { user } = useAuth();
	const unreadMessageCount = useGetUnreadMessageCount(user?.userName!);

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const navigate = useNavigate();

	return (<>
		<Button
			className='new-messages-button'
			onClick={() => setPopupVisibility(true)}
		>
			<div className='new-messages-icon'>
				<i className='dx-icon dx-icon-Inscyth-Chat'></i>
				{
					!!unreadMessageCount.data && unreadMessageCount.data > 0 &&
					<div className='new-messages-counter'>{unreadMessageCount.data}</div>
				}
			</div>
		</Button>
		{
			isPopupVisible &&
			<Popup
				className='new-messages-popup-wrapper'
				visible={true}
				showTitle={true}
				title="New Inbound Messages"
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
				width={500}
				height={'70vh'}
				shading={false}
				position={{
					my: 'right top', at: 'right bottom', of: '.new-messages-button', collision: 'none'
				}}
			>
				<div className='new-messages-popup'>
					<NewMessageList onMessageClicked={(message) => {
						setPopupVisibility(false);
						navigate(`/cfi/retail-order/${message.orderID}`, { state: { messageID: message.notificationQueueID}});
					}} />
				</div>
			</Popup>
		}
	</>)
}